import type { Citation } from "@/lib/types";

export const isPrassi = (c?: Pick<Citation, "document_name"> | null): boolean =>
  !!c?.document_name && c.document_name.startsWith("PRASSI__");

export const getPrassiCategoria = (docName?: string | null): string => {
  const m = docName?.match(/^PRASSI__([^_]+)__/);
  return m ? m[1] : "altro";
};

const PRASSI_LABELS = [
  "TOPIC",
  "FONTE",
  "PRODOTTI",
  "BRAND",
  "CATEGORIA",
  "PRASSI",
  "NOTE",
  "STANDARD DI RIFERIMENTO",
  "VERIFICA",
] as const;

export type PrassiSections = Partial<Record<string, string>>;

export const parsePrassiContent = (content?: string | null): PrassiSections => {
  if (!content) return {};
  const sections: PrassiSections = {};
  for (let i = 0; i < PRASSI_LABELS.length; i++) {
    const lbl = PRASSI_LABELS[i];
    const next = PRASSI_LABELS[i + 1];
    const lblPat = lbl.replace(/ /g, "\\s");
    const nextPat = next ? next.replace(/ /g, "\\s") + "\\s*:" : "$";
    const re = new RegExp(`^${lblPat}:\\s*([\\s\\S]*?)(?=\\n${nextPat})`, "m");
    const match = content.match(re);
    if (match) {
      const key = lbl.toLowerCase().replace(/ /g, "_");
      sections[key] = match[1].trim();
    }
  }
  return sections;
};

export const cleanPrassiName = (docName?: string | null): string => {
  if (!docName) return "Prassi";
  const noPrefix = docName.replace(/^PRASSI__/, "");
  const noExt = noPrefix.replace(/\.txt$/i, "");
  return noExt.split("__").filter(Boolean).join(" — ");
};

export interface TransparencyAggregate {
  n_sources: number;
  n_prassi: number;
  n_manuali: number;
  brands: string[];
}

export const aggregateTransparency = (
  citations: Citation[],
  brands: string[],
): TransparencyAggregate => {
  const n_prassi = citations.filter(isPrassi).length;
  const n_manuali = citations.length - n_prassi;
  return {
    n_sources: citations.length,
    n_prassi,
    n_manuali,
    brands,
  };
};